import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    stisLoading : false,
    reservationEmail: [],
    totalReservationEmail: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    stiscLoading:false,
    stcstatus:"",
    stcmessage:"",
    stcMessage:"",
    stdetails:{},
    stismloading:false,
    stmstatus:"",
    stmmessage:"",
    stSDetails: {},
    stdstatus:"",
    stdmessage:"",
    error:"",
    
};


const reservationEmailSlice = createSlice({
    name: "reservationEmailsList",
    initialState,
    reducers:{
        getReservationEmailPending: (state) => {
            state.stisLoading = true;
        },
        getReservationEmailSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.reservationEmail = payload;
            state.stdetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getReservationEmailFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        createReservationEmailPending:(state,action) => {
            state.stiscloading=true;
        },
        createReservationEmailSuccess:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="success";
            state.stcmessage=payload;
        },
        createReservationEmailFail:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="fail";
            //console.log('slice '+payload);
            state.stcmessage=payload;
        },
        getSReservationEmailPending: (state) => {
            state.stisLoading = true;
        },
        getSReservationEmailSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.stSDetails=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSReservationEmailFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        modifyReservationEmailPending:(state,action) => {
            state.stismloading=true;
            state.stmstatus="";
        },
        modifyReservationEmailSuccess:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="success";
           
            state.stmmessage="Reservation Email Successfully Updated";
        },
        modifyReservationEmailail:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="fail";
           // console.log('slice '+payload);
            state.stmmessage=payload;
        },
        deleteReservationEmailPending:(state,action) => {
            state.stisloading=true;
            state.stdstatus="";
        },
        deleteReservationEmailSuccess:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="success";
            state.stdmessage="Reservation Email Successfully Deleted";
        },
        deleteReservationEmailFail:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="fail";
           // console.log('slice '+payload);
            state.stdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = reservationEmailSlice;

export const { getReservationEmailPending, getReservationEmailSuccess, getReservationEmailFail,getSReservationEmailPending, getSReservationEmailSuccess, getSReservationEmailFail, 
    createReservationEmailPending, createReservationEmailSuccess, createReservationEmailFail,
    modifyReservationEmailPending,modifyReservationEmailSuccess,modifyReservationEmailFail,
    deleteReservationEmailPending,deleteReservationEmailSuccess,deleteReservationEmailFail  } = actions;

export default reducer;
